import React from 'react'
import ReactModal from 'react-modal'
import styles from './MessageDialog.scss'
import { imageAssetUrl } from '@libs/appUrl'

function MessageDialog(props) {
  const { isOpen, onClose, title, message } = props
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      closeTimeoutMS={300}
      className="Modal"
      overlayClassName="Overlay"
      ariaHideApp={false}
      id="popapp-message-dialog"
    >
      <style jsx>{styles}</style>
      <div className="content">
        <div className="titleBar">
          <div className="title">{title}</div>
          <img className="closeBtn" src={imageAssetUrl('icon/close@3x.png')} onClick={onClose} />
        </div>
        <div className="message">{message}</div>
      </div>
    </ReactModal>
  )
}

export default MessageDialog
